<template>
  <div class="flexCss list-box common-shadow" style="margin: 20px">
    <vxe-form
        ref="xForm"
        class="my-form3"
        title-align="right"
        title-width="110"
        :data="formData"
        :rules="formRules"
        style="margin-top: 20px; padding: 0 36px;width: 100%;display: flex; flex-direction: column;align-items: center;"
        @submit="submitEvent">
      <div class="infoCssPadding">
        <div>
          <div class="bit">
            <img src="@/assets/images/common/comp.png"/>
            <span class="bit-title">企业信息:</span>
          </div>
          <div class="border-shadow">
            <Row>
              <Col span="8">
                <vxe-form-item title="上传营业执照" field="businessUrl" :title-width="150" title-align="right" span="24">
                  <upload-img :row="formData" :fileKey="'businessUrl'" :width="58" :height="58" :isOcrBusiness="true"
                              :initFile="formData.businessUrl" @getOcrBusiness="getOcrBusiness"></upload-img>
                </vxe-form-item>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <vxe-form-item title="企业名称" field="compName" span="8" :title-width="150" title-align="right"
                               class="inputWidthCss">
                  <template v-slot="scope">
                    <vxe-input class="formInput" v-model="formData.compName" placeholder="必填"
                               :disabled="formData.aboutCompId != null"
                               @input="(file)=>checkCompName(file,scope)"
                               @change="$refs.xForm.updateStatus(scope)" @blur="checkComp"></vxe-input>
                  </template>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="统一社会信用码" field="taxNum" span="8" :title-width="150" title-align="right">
                  <template v-slot="scope">
                    <vxe-input class="formInput" v-model="formData.taxNum" placeholder="必填"
                               @change="$refs.xForm.updateStatus(scope)"></vxe-input>
                  </template>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="注册地址" field="regAddr" :title-width="150" span="8" title-align="right">
                  <vxe-input class="formInput" v-model="formData.regAddr" placeholder="必填"></vxe-input>
                </vxe-form-item>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <vxe-form-item title="注册电话" field="regPhone" :title-width="150" span="8" title-align="right">
                  <vxe-input class="formInput" v-model="formData.regPhone" placeholder="选填"></vxe-input>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="开户银行" field="bankName" :title-width="150" span="8" title-align="right">
                  <vxe-input class="formInput" v-model="formData.bankName" placeholder="选填"></vxe-input>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="开户账号" field="accountNum" :title-width="150" span="8" title-align="right">
                  <vxe-input class="formInput" v-model="formData.accountNum" placeholder="选填"></vxe-input>
                </vxe-form-item>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <vxe-form-item title="归属区域" field="busiOwnArea" span="8" :title-width="150" title-align="right">
                  <Cascader
                      v-model="formData.busiOwnArea"
                      :data="home_port"
                      trigger="hover"
                      style="width: 300px"
                  ></Cascader>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="法人姓名" field="realName" :title-width="150" title-align="right" span="12">
                  <template #title>
                    <span style="color: #f56c6c;">*</span>
                    <span>法人姓名</span>
                  </template>
                  <template v-slot="scope">
                    <vxe-input class="formInput" v-model="formData.realName" placeholder="必填"
                               @input="$refs.xForm.updateStatus(scope)"></vxe-input>
                  </template>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="绑定手机号" field="regisiterNum" :title-width="150" title-align="right" span="8">
                  <template v-slot="scope">
                    <vxe-input class="formInput" v-model="formData.regisiterNum" placeholder="用户登录手机号勿乱填"
                               @input="$refs.xForm.updateStatus(scope)"></vxe-input>
                  </template>
                </vxe-form-item>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div class="infoCssPadding">
        <div>
          <div class="bit">
            <img src="@/assets/images/common/daolu.png"/>
            <span class="bit-title">运输经营许可证:</span>
            <i-switch style="margin-left: 5px;" v-model="formData.isShowTransportLic"></i-switch>
          </div>
          <div class="border-shadow" v-show="formData.isShowTransportLic">
            <Row>
              <Col span="8">
                <vxe-form-item title="运输经营许可证" field="transportLicenseUrl" :title-width="150" title-align="right"
                               span="24">
                  <upload-img :row="formData" :fileKey="'transportLicenseUrl'" :width="58" :height="58"
                              :initFile="formData.transportLicenseUrl"></upload-img>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="经营许可证号" field="businessLicenseNum" :title-width="150" title-align="right"
                               span="12">
                  <template v-slot="scope">
                    <div style="height: 80px;display: flex;align-items: center;">
                      <vxe-input class="formInput" v-model="formData.businessLicenseNum" placeholder="必填"
                                 @input="$refs.xForm.updateStatus(scope)"></vxe-input>
                    </div>
                  </template>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="有效期至" field="businessExpireTime" :title-width="150" title-align="right"
                               span="8">
                  <div style="height: 80px;display: flex;align-items: center;">
                    <vxe-input class="formInput" type="date" v-model="formData.businessExpireTime"
                               placeholder="请选择日期"></vxe-input>
                  </div>
                </vxe-form-item>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div class="infoCssPadding">
        <div>
          <div class="bit">
            <img src="@/assets/images/common/link.png"/>
            <span class="bit-title">联系人信息:</span>
          </div>
          <div class="border-shadow">
            <Row>
              <Col span="8">
                <vxe-form-item title="联系人" field="linkman" :title-width="150" title-align="right" span="7">
                  <template v-slot="scope">
                    <vxe-input class="formInput" v-model="formData.linkman" placeholder="选填"
                               @input="$refs.xForm.updateStatus(scope)"></vxe-input>
                  </template>
                </vxe-form-item>
              </Col>
              <Col span="8">
                <vxe-form-item title="联系方式" field="phoneNum" :title-width="150" title-align="right" span="7">
                  <vxe-input class="formInput" v-model="formData.phoneNum" placeholder="选填"></vxe-input>
                </vxe-form-item>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div class="infoCssPadding">
        <div>
          <div class="bit">
            <img src="@/assets/images/common/bank.png"/>
            <span class="bit-title">银行账户:</span>
          </div>
          <div class="border-shadow">
            <vxe-table
                style="margin-top: 10px;width:100%;"
                ref="xBankTable"
                border
                show-overflow
                size="mini"
                :data="tableData"
                :edit-config="{ trigger: 'click', mode: 'cell' }"
            >
              <vxe-table-column width="50" align="center">
                <template v-slot:header>
                  <Button class="add-btn" icon="md-add" @click="insertEvent()"></Button>
                </template>
                <template v-slot="{ row }">
                  <Button class="del-btn" icon="md-remove" @click="delRow(row)"></Button>
                </template>
              </vxe-table-column>
              <vxe-table-column field="accountName" title="户名">
                <template v-slot="{ row }">
                  <vxe-input v-model="row.accountName" placeholder="选填" @input="(file)=>checkAccName(file,row)"
                             @blur="(file)=>checkAccRule(file,row)"></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column field="openBankName" title="开户行">
                <template v-slot="{ row,$rowIndex }">
                  <vxe-pulldown :ref="'bankDown'+ $rowIndex" transfer style="width: 100%">
                    <template v-slot>
                      <vxe-input v-model="row.openBankName" placeholder="请选择开户行"
                                 @focus="bankFocusEvent(row,'bankDown'+ $rowIndex)"
                                 @keyup="bankKeyupEvent(row)" @blur="checkOrg(row)"></vxe-input>
                    </template>
                    <template v-slot:dropdown>
                      <div class="my-dropdown1">
                        <div class="list-item1" v-for="item in bankList" :key="item.id"
                             @click="bankSelectEvent(item,row,'bankDown'+ $rowIndex)">
                          <i class="fa fa-user-o"></i>
                          <span>{{ item.orgName }}</span>
                        </div>
                      </div>
                    </template>
                  </vxe-pulldown>
                </template>
              </vxe-table-column>
              <vxe-table-column field="accountNum" title="银行账号">
                <template v-slot="{ row }">
                  <vxe-input
                      v-model="row.accountNum"
                      placeholder="选填"
                      @input="(file)=>checkAccNum(file,row)"
                  ></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column title="是否默认" field="isDefault">
                <template v-slot="{ row,$rowIndex }">
                  <!--                  <vxe-switch v-model="row.isDefault" open-label="是" close-label="否" open-value="1" close-value="0"></vxe-switch>-->
                  <vxe-select v-model="row.isDefault" placeholder="是否默认" clearable transfer
                              @change="isDefaultChange(row,$rowIndex)">
                    <vxe-option :value=1 label="是"></vxe-option>
                    <vxe-option :value=0 label="否"></vxe-option>
                  </vxe-select>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </div>
        <div>
          <div class="bit">
            <img src="@/assets/images/common/addres.png"/>
            <span class="bit-title">邮寄地址:</span>
          </div>
          <div class="border-shadow">
            <vxe-table
                style="margin-top: 10px;width:100%;"
                ref="xEmailTable"
                border
                show-overflow
                size="mini"
                :data="tableData2"
                :edit-config="{ trigger: 'click', mode: 'cell' }"
            >
              <vxe-table-column width="50" align="center">
                <template v-slot:header>
                  <Button class="add-btn" icon="md-add" @click="insertEvent2()"></Button>
                </template>
                <template v-slot="{ row }">
                  <Button class="del-btn" icon="md-remove" @click="delRow2(row)"></Button>
                </template>
              </vxe-table-column>
              <vxe-table-column field="linkMan" title="联系人">
                <template v-slot="{ row }">
                  <vxe-input v-model="row.linkMan" placeholder="选填"></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column field="linkPhone" title="联系电话">
                <template v-slot="{ row }">
                  <vxe-input v-model="row.linkPhone" placeholder="选填"></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column field="pro" title="省市区">
                <template v-slot="{ row }">
                  <Cascader
                      v-model="row.pro"
                      :data="home_port"
                      trigger="hover"
                      transfer
                  ></Cascader>
                </template>
              </vxe-table-column>
              <vxe-table-column field="content" title="详细地址">
                <template v-slot="{ row }">
                  <vxe-input v-model="row.content" placeholder="选填"></vxe-input>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </div>
      </div>
      <vxe-form-item align="center" span="24" style="margin-top: 20px">
        <vxe-button status="primary" @click="close">取消</vxe-button>
        <vxe-button type="submit" status="primary">完成</vxe-button>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>
<script>
import UploadImg from "@/components/common/UploadImg";
import {hideLoading, isEmpty, showLoading} from "@/utils/util";
import $api from "@/apiProvider";
import md5 from "js-md5";

export default {
  components: {UploadImg},
  data() {
    const compNameValid = ({cellValue}) => {
      if (this.formData.userType === 2) {
        let reg = new RegExp(/^[\u4e00-\u9fa5_a-zA-Z（）]+$/);
        let valid = reg.test(this.formData.compName);
        if (!valid) {
          return Promise.reject(new Error("请输入正确的企业名称"));
        }
      }
    };
    return {
      formDataCopy: {},
      managerType: [
        {
          label: '法定代表人',
          value: 1,
        }, {
          label: '非法定代表人',
          value: 2,
        }
      ],
      formData: {
        bankName: null,
        compName: null,
        faxNum: null,
        idcardNum: null,
        idCardExpireTime: null,
        regisiterNum: null,
        driverCardNum: null,
        driverModel: null,
        issueAuthority: null,
        driverBeginTime: null,
        driverExpireTime: null,
        weightType: null,
        transportLicenseNum: null,
        transportExpireTime: null,
        phoneNum: null,
        realName: null,
        idcardBackUrl: null,
        userTypeDisd: true,
        idcardFrontUrl: null,
        businessUrl: null,
        transportLicenseUrl: null,
        businessExpireTime: null,
        businessLicenseNum: null,
        qualificationUrl: null,
        drivingCardFrontUrl: null,
        drivingCardSubpageUrl: null,
        busiOwnArea: [],
        regAddr: null,
        nextError: false,
        regPhone: null,
        taxNum: null,
        accountName: null,
        accountNum: null,
        userType: 2,
        userCategory: null,
        managerType: null,
        managerPhone: null,
        managerName: null,
        isShowTransportLic: false,
        userAddressBankInfo: [
          {
            accountName: null,
            accountNum: null,
            openBankName: null,
            openOrgNum: null
          },
        ],
        userAddressInfor: [
          {
            content: null,
            linkMan: null,
            linkPhone: null,
          },
        ],
      },
      formRules: {
        compName: [{required: true, message: "请输入公司名称"},
          {min: 5, max: 30, message: '请输入正确的企业名称'},
          {validator: compNameValid}],
        idcardNum: [
          {min: 18, max: 18, message: '请输入正确的身份证号'}
        ],
        driverCardNum: [
          {min: 18, max: 18, message: '请输入正确的驾驶证号'}
        ],
        transportLicenseNum: [
          {min: 18, max: 18, message: '请输入正确的从业资格证号'}
        ],
        taxNum: [
          {min: 18, max: 18, message: '请输入正确的统一社会信用码'},
          {required: true, message: "请输入统一社会信用码"}
        ],
        managerPhone: [{min: 11, max: 11, message: '请输入正确的手机号'}],
        realName: [{required: true, message: '请输入法人姓名'}],
        busiOwnArea: [{required: true, message: '请选择归属区域'}],
        regisiterNum: [{min: 11, max: 11, message: '请输入正确的手机号'}],
        regPhone: [{min: 11, max: 11, message: '请输入正确的手机号'}],
        // bankName: [{required: true, message: "请输入开户银行"}],
        // accountNum: [{required: true, message: "请输入开户账号"}],
        transportLicenseUrl: [{required: true, message: "请上传运输经营许可证"}],
        businessLicenseNum: [{required: true, message: "请输入经营许可证号"}],
        businessExpireTime: [{required: true, message: "请选择有效期"}],
        regAddr: [
          {required: true, message: '请输入正确地址'}
        ]
      },
      bankList: [],
      tableData: [{
        isDefault: 1
      }],
      tableData2: [{
        pro: []
      }],
      home_port: [],
    }
  },
  mounted() {
    document.title = '创建企业客户'
    this.getHomePort();
  },
  methods: {
    async checkComp() {
      let res = await $api.baseUserSign.get("queryUserInfoByCompName", {
        compName: this.formData.compName
      });
      if (res.status === 1) {
        if (res.data.id) {
          this.$XModal.alert({
            message: this.formData.compName + '已存在',
            status: "error",
          });
          return
        }
      }
    },
    checkAccName(e, row) {
      row.accountName = e.replace('(', '（').replace(')', '）');
    },
    checkAccNum(e, row) {
      row.accountNum = e.replace(/[^\d]/g, '');
    },
    checkAccRule(e, row) {
      let reg = new RegExp(/^[\u4e00-\u9fa5（）]+$/);
      let valid = reg.test(e.value);
      if (e.value.length < 2 || e.value.length > 30 || !valid) {
        this.$XModal.alert({
          message: "请输入正确的户名",
          status: "error",
        });
        row.accountName = null;
        return;
      }
    },
    getOcrBusiness(data) {
      this.$set(this.formData, 'compName', data.danweimingcheng.replace('(', '（').replace(')', '）'));
      this.$set(this.formData, 'taxNum', data.shehuixinyongdaima);
      this.$set(this.formData, 'regAddr', data.dizhi);
      this.$set(this.formData, 'realName', data.faren);
      this.checkComp();
    },
    async getHomePort() {
      showLoading()
      let res = await $api.xcwDict.request('queryProCityAreaList');
      hideLoading();
      if (res.code === 1) {
        let province = [];
        res.data.map(i => {
          if (i.cityCodeP === '0') {
            province.push({
              label: i.cityText,
              value: i.cityCode,
              children: []
            })
          }
        })
        province.map(i => {
          res.data.map(j => {
            if (i.value === j.cityCodeP) {
              i.children.push({
                label: j.cityText,
                value: j.cityCode,
                children: []
              })
            }
          })
        })
        province.map(i => {
          i.children.map(j => {
            res.data.map(k => {
              if (j.value === k.cityCodeP) {
                j.children.push({
                  label: k.cityText,
                  value: k.cityCode,
                })
              }
            })
          })
        })

        this.home_port = province;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    checkCompName(e, scope) {
      this.formData.compName = e.replace('(', '（').replace(')', '）');
    },
    insertEvent(row) {
      let record = {
        isDefault: 1
      };
      if (this.$refs.xBankTable.getTableData().tableData.length === 0) {
        record.isDefault = 1
        this.$refs.xBankTable.insertAt(record, row);
      } else {
        record.isDefault = 0
        this.$refs.xBankTable.insertAt(record, row);
      }
    },
    insertEvent2(row) {
      let record = {
        pro: []
      };
      this.$refs.xEmailTable.insertAt(record, row);
    },
    delRow(e) {
      this.$refs.xBankTable.remove(e);
    },
    delRow2(e) {
      this.$refs.xEmailTable.remove(e);
    },
    isDefaultChange(row, $rowIndex) {
      if (row.isDefault == 1) {
        this.$refs.xBankTable.getTableData().fullData.forEach((item, index) => {
          if (index != $rowIndex) {
            item.isDefault = 0;
          }
        })
      }
    },
    async getBankListByName(row) {
      let name = row.openBankName;
      if (isEmpty(name)) {
        this.bankList = [];
        return
      }
      let res = await $api.finance.get(`cebBankOrg/searchOrgByName/${name}`);
      if (res.status == 1 && res.message === name) {
        this.bankList = res.data;
      }
    },
    bankFocusEvent(row, name) {
      row.chooseBank = false;
      this.$refs[name].showPanel();
    },
    bankKeyupEvent(row) {
      this.getBankListByName(row);
    },
    bankSelectEvent(obj, row, name) {
      row.chooseBank = true;
      row.openBankName = obj.orgName;
      row.openOrgNum = obj.orgNum;
      this.$refs[name].hidePanel();
    },
    checkOrg(row) {
      if (!row.openOrgNum || !row.chooseBank) {
        row.openBankName = '';
      }
    },
    copyTemp() {
      this.formDataCopy = {
        userAddressBankInfo: [],
        userAddressInfor: [],
      };

      if (this.formData.password == null || this.formData.password === "") {
        this.formDataCopy.password = md5("666888");
      } else {
        this.formDataCopy.password = md5(this.formData.password);
      }
      this.formDataCopy.transportLicenseUrl = this.formData.transportLicenseUrl;
      if (this.formData.businessExpireTime) {
        this.formDataCopy.businessExpireTime = this.$utils.timestamp(this.formData.businessExpireTime);
      }
      this.formDataCopy.businessLicenseNum = this.formData.businessLicenseNum;
      this.formDataCopy.userType = this.formData.userType;
      if (this.formData.realName && this.formData.realName !== '') {
        this.formDataCopy.realName = this.formData.realName.replace(/\s*/g, "");
      }
      this.formDataCopy.faxNum = this.formData.faxNum;
      this.formDataCopy.idcardNum = this.formData.idcardNum;
      this.formDataCopy.phoneNum = this.formData.phoneNum;
      this.formDataCopy.regAddr = this.formData.regAddr;
      this.formDataCopy.regPhone = this.formData.regPhone;
      this.formDataCopy.taxNum = this.formData.taxNum;
      this.formDataCopy.openBankName = this.formData.openBankName;
      this.formDataCopy.openOrgNum = this.formData.openOrgNum;
      this.formDataCopy.accountNum = this.formData.accountNum;
      if (this.formData.compName && this.formData.compName !== '') {
        this.formDataCopy.compName = this.formData.compName.replace(/\s*/g, "");
      }
      this.formDataCopy.aboutCompId = this.formData.aboutCompId;
      this.formDataCopy.aboutCompName = this.formData.aboutCompName;
      if (this.formData.accountName && this.formData.accountName !== '') {
        this.formDataCopy.accountName = this.formData.accountName.replace(/\s*/g, "");
      }
      this.formDataCopy.idcardBackUrl = this.formData.idcardBackUrl;
      this.formDataCopy.businessUrl = this.formData.businessUrl;
      this.formDataCopy.idcardFrontUrl = this.formData.idcardFrontUrl;
      this.formDataCopy.linkman = this.formData.linkman;
      this.formDataCopy.managerType = this.formData.managerType;
      this.formDataCopy.managerPhone = this.formData.managerPhone;
      this.formDataCopy.managerName = this.formData.managerName;

      this.formDataCopy.bankName = this.formData.bankName;

      this.formDataCopy.busiOwnArea = this.formData.busiOwnArea.toString();
      this.formDataCopy.isShowTransportLic = this.formData.isShowTransportLic ? 1 : 0;

      this.formDataCopy.userName = this.formData.compName;


      if (this.formData.idCardExpireTime) {
        this.formDataCopy.idCardExpireTime = this.$utils.timestamp(this.formData.idCardExpireTime);
      }
      this.formDataCopy.regisiterNum = this.formData.regisiterNum;
      this.formDataCopy.driverCardNum = this.formData.driverCardNum;
      this.formDataCopy.driverModel = this.formData.driverModel;
      this.formDataCopy.issueAuthority = this.formData.issueAuthority;
      if (this.formData.driverBeginTime) {
        this.formDataCopy.driverBeginTime = this.$utils.timestamp(this.formData.driverBeginTime);
      }
      if (this.formData.driverExpireTime) {
        this.formDataCopy.driverExpireTime = this.$utils.timestamp(this.formData.driverExpireTime);
      }
      this.formDataCopy.weightType = this.formData.weightType;
      this.formDataCopy.transportLicenseNum = this.formData.transportLicenseNum;
      if (this.formData.transportExpireTime) {
        this.formDataCopy.transportExpireTime = this.$utils.timestamp(this.formData.transportExpireTime);
      }

      if (this.$refs.xBankTable != null) {
        this.formDataCopy.userAddressBankInfo = this.copyDeep(
            this.$refs.xBankTable.getTableData().fullData
        );
        let deleteArr = [];
        this.formDataCopy.userAddressBankInfo.map((i, index) => {
          if (!i.accountName && !i.accountNum && !i.openBankName) {
            deleteArr.push(index);
          }
        })
        deleteArr.map(i => {
          delete this.formDataCopy.userAddressBankInfo[i];
        })
      }
      if (this.$refs.xEmailTable != null) {
        this.formDataCopy.userAddressInfor = this.copyDeep(
            this.$refs.xEmailTable.getTableData().fullData
        );
        this.formDataCopy.userAddressInfor.map(i => {
          if (i.pro && i.pro.length > 0) {
            i.pro = i.pro.toString();
          } else {
            i.pro = null;
          }
        })

        let deleteArr = [];
        this.formDataCopy.userAddressInfor.map((i, index) => {
          if (!i.content && !i.linkMan && !i.linkPhone && !i.pro) {
            deleteArr.push(index);
          }
        })
        deleteArr.map(i => {
          delete this.formDataCopy.userAddressInfor[i];
        })
      }
    },
    async submitEvent() {
      let self = this;
      this.loading = true;
      if (this.formData.realName == null || this.formData.realName === "") {
        this.$XModal.alert({
          message: "请输入法人姓名",
          status: "error",
        });
        this.loading = false;
        return;
      }

      // if (this.formData.bankName === null || this.formData.bankName === "") {
      //   this.$XModal.alert({
      //     message: "请输入开户银行",
      //     status: "error",
      //   });
      //   this.loading = false;
      //   return;
      // }
      //
      // if (this.formData.accountNum === null || this.formData.accountNum === "") {
      //   this.$XModal.alert({
      //     message: "请输入开户账号",
      //     status: "error",
      //   });
      //   this.loading = false;
      //   return;
      // }

      if (!this.formData.busiOwnArea || this.formData.busiOwnArea.length === 0) {
        this.$XModal.alert({
          message: "请选择归属区域",
          status: "error",
        });
        this.loading = false;
        return;
      }
      let reg = new RegExp(/^[\u4e00-\u9fa5_a-zA-Z（）]+$/);
      let valid = reg.test(this.formData.compName);
      if (this.formData.compName === null || this.formData.compName === "" || this.formData.compName.length < 8 || this.formData.compName.length > 30 || !valid) {
        this.$XModal.alert({
          message: "请输入正确的企业名称",
          status: "error",
        });
        this.loading = false;
        return;
      }

      let regPhone = new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/);
      let validPhone = regPhone.test(this.formData.regisiterNum);
      if (this.formData.regisiterNum && this.formData.regisiterNum !== '' && this.formData.regisiterNum.length !== 11 && !validPhone) {
        this.$XModal.alert({
          message: "请输入正确的注册手机号",
          status: "error",
        });
        this.loading = false;
        return;
      }

      // if (this.formData.regPhone === null || this.formData.regPhone === "") {
      //   this.$XModal.alert({
      //     message: "请输入注册电话",
      //     status: "error",
      //   });
      //   this.loading = false;
      //   return;
      // }

      let validPhoneNum = regPhone.test(this.formData.phoneNum);
      if (this.formData.phoneNum && this.formData.phoneNum !== '' && !validPhoneNum) {
        this.$XModal.alert({
          message: "请输入正确的联系方式",
          status: "error",
        });
        this.loading = false;
        return;
      }

      // let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      // let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      // let validIDre = _IDRe18.test(this.formData.idcardNum) || _IDre15.test(this.formData.idcardNum);
      // if (this.formData.idcardNum && this.formData.idcardNum !== '' && this.formData.idcardNum.length !== 18 && !validIDre) {
      //   this.$XModal.alert({
      //     message: "请输入正确的身份证号码",
      //     status: "error",
      //   });
      //   this.loading = false;
      //   return;
      // }
      if (this.formData.taxNum == null || this.formData.taxNum === "") {
        this.$XModal.alert({
          message: "请输入社会统一信用码",
          status: "error",
        });
        this.loading = false;
        return;
      }

      let regTax = new RegExp(/^(([0-9A-Z]{18}))$/);
      let validTax = regTax.test(this.formData.taxNum);
      if (!validTax) {
        this.$XModal.alert({
          message: "请输入正确的统一社会信用码",
          status: "error",
        });
        this.loading = false;
        return;
      }


      if (this.formData.regAddr == null || this.formData.regAddr === "") {
        this.$XModal.alert({
          message: "请输入注册地址",
          status: "error",
        });
        this.loading = false;
        return;
      }

      if (this.isShowTransportLic) {
        if (this.formData.transportLicenseUrl == null || this.formData.transportLicenseUrl === "") {
          this.$XModal.alert({
            message: "请上传运输经营许可证",
            status: "error",
          });
          this.loading = false;
          return;
        }

        if (this.formData.businessLicenseNum == null || this.formData.businessLicenseNum === "") {
          this.$XModal.alert({
            message: "请输入经营许可证号",
            status: "error",
          });
          this.loading = false;
          return;
        }

        if (this.formData.businessExpireTime == null || this.formData.businessExpireTime === "") {
          this.$XModal.alert({
            message: "请选择有效期",
            status: "error",
          });
          this.loading = false;
          return;
        }
      }

      self.copyTemp();
      this.createAndSaveBaseUserSign();
    },
    async createAndSaveBaseUserSign() {
      showLoading();
      let res = await $api.gcdUser
          .request("createAndSaveBaseUserSign", this.formDataCopy)
          .catch(function (er) {
            console.log(er.response.data.message);
            self.$XModal.alert({
              message: er.response.data.message
                  ? er.response.data.message
                  : "接口异常",
              status: "error",
            });
            return;
          });
      hideLoading();
      if (res.status === 1) {
        this.$Message["success"]({
          background: true,
          content: "创建成功",
        });
        this.close();
        window.close();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        this.loading = false;
      }
    },
    copyDeep(templateData) {
      // templateData 是要复制的数组或对象，这样的数组或者对象就是指向新的地址的
      return JSON.parse(JSON.stringify(templateData));
    },
    close() {
      window.close();
      this.$bus.$emit("closeProcedureDetail", '新建企业客户');
      this.$bus.$emit("afterCreateCompany", true);

      this.formData = {
        bankName: null,
        compName: null,
        faxNum: null,
        idcardNum: null,
        idCardExpireTime: null,
        regisiterNum: null,
        driverCardNum: null,
        driverModel: null,
        issueAuthority: null,
        driverBeginTime: null,
        driverExpireTime: null,
        weightType: null,
        transportLicenseNum: null,
        transportExpireTime: null,
        phoneNum: null,
        realName: null,
        regAddr: null,
        regPhone: null,
        taxNum: null,
        accountName: null,
        accountNum: null,
        userType: 2,
        isShowTransportLic: false,
        busiOwnArea: [],
        userAddressBankInfo: [
          {
            accountName: null,
            accountNum: null,
            openBankName: null,
            openOrgNum: null
          },
        ],
        userAddressInfor: [
          {
            content: null,
            linkMan: null,
            linkPhone: null,
          },
        ],
      };
      this.tableData = [{
        isDefault: 1
      }];
      this.tableData2 = [{
        pro: []
      }];
      this.$refs.xForm.clearValidate();
    },
  }
}
</script>

<style>
body {
  overflow: scroll !important;
}

.StepCss {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.StepCss > .ivu-steps {
  width: 50%;
}

.flexCss {
  display: flex;
  justify-content: center;
}

.fontWeight {
  font-weight: 800;
  margin-bottom: 10px;
  color: #2d8cf0;
  display: inline-block;
}

.infoCssPadding {
  width: 100%;
}

.vxe-form .infoCssPadding .vxe-form--item {
  display: none;
  width: 100%;
}

/*.infoCssPadding .vxe-input:not(.is--disabled).is--active .vxe-input--inner {*/
/*  border: 0px solid #409eff;*/
/*}*/

.infoCssPadding .vxe-input--inner {
  width: 100%;
  height: 100%;
  /* border-radius: 4px; */
  outline: 0;
  padding: 0 0.6em;
  color: #606266;
  /*border: 0px solid #dcdfe6;*/
  background-color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.inputWidthCss .vxe-input input {
  max-width: 300px;
}

.inputWidthCss .ivu-row {
  border-bottom: 1px solid rgba(232, 234, 236, 1);
}

.infoCssPadding .ivu-btn-icon-only {
  width: 24px;
  height: 24px;
  padding: 0;
  font-size: 16px;
  border-radius: 4px;
}

.upload-list2-wrap {
  display: flex;
  flex-wrap: wrap;
}

.upload-list2 {
  display: inline-block;
  width: 120px;
  height: 120px;
  text-align: center;
  line-height: 120px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0.2);
  margin-left: 4px;
  vertical-align: middle;
  margin-bottom: 10px;
}

.upload-list2 img {
  width: 100%;
  height: 100%;
  border-style: none;
}

.add-box .file-upload-box2 {
  height: 120px;
  width: 120px;
  line-height: 120px;
  border: 1px dashed #dcdee2;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
}

.upload-list2:hover .upload-list2-cover {
  display: block;
}

.upload-list2-cover {
  display: none;
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.6);
  width: 20px;
  height: 20px;
  border-radius: 10px;
  text-align: center;
}

.upload-list2-cover i {
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  margin: 0 auto;
  text-indent: 0;
  display: block;
  width: 100%;
  height: 100%;
  line-height: 20px;
}

.upload-list2 .pdf-box2 {
  height: 120px;
  width: 120px;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
}

.bit {
  display: flex;
  align-items: center;
  margin: 20px 0;
}

.bit-tip {
  width: 4px;
  height: 16px;
  background: #539FFF;
}

.bit-title {
  margin-left: 4px;
  height: 21px;
  line-height: 21px;
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #438DF3;
}

.formInput {
  max-width: 300px;
}

.my-dropdown1 {
  height: 200px;
  overflow: auto;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
}

.list-item1:hover {
  background-color: #f5f7fa;
}

.border-shadow {
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.16);
  padding: 20px 30px;
  box-sizing: border-box;
}

.border-shadow .ivu-row {
  display: flex;
  align-items: center;
}
</style>